import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export const PostCard = ({ post, featured = false }) => (
  <Link
    to={`/blog/${post.slug}`}
    className={`group block rounded-xl border border-[#E5E1DB] bg-white overflow-hidden transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/5 ${featured ? "md:grid md:grid-cols-2" : ""}`}
    data-testid={`blog-post-card-${post.slug}`}
  >
    <div className={`overflow-hidden bg-[#E5E1DB] ${featured ? "aspect-[16/10] md:aspect-auto md:h-full" : "aspect-[16/10]"}`}>
      {post.cover_image && (
        <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
      )}
    </div>
    <div className={featured ? "p-8 sm:p-10 flex flex-col justify-center" : "p-6"}>
      <div className="flex items-center gap-3 text-xs text-[#5C6B64]">
        <span className="tracking-[0.2em] uppercase font-semibold text-[#C65D47]">{post.category}</span>
        <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{post.read_minutes} min read</span>
      </div>
      <h3 className={`font-display tracking-tight mt-3 group-hover:text-[#C65D47] transition-colors ${featured ? "text-2xl sm:text-3xl" : "text-xl"}`}>
        {post.title}
      </h3>
      <p className="text-sm text-[#5C6B64] mt-3 leading-relaxed line-clamp-3">{post.description}</p>
      <p className="text-xs text-[#5C6B64] mt-4">{formatDate(post.published_at)}</p>
    </div>
  </Link>
);
